import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { SavingService } from '../services/saving/saving.service';

const MUTATING_METHODS = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);

/**
 * Marks the app as "saving" for the lifetime of any mutating request to the
 * registration API (step saves, uploads, /complete). The counter is released
 * on complete OR error via finalize, so the footer never stays stuck. Read
 * requests (lookups, eligibility, school info) are ignored so navigation and
 * data loads don't spin the save button.
 */
export function savingInterceptor(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const isRegistrationSave =
    MUTATING_METHODS.has(request.method.toUpperCase()) &&
    request.url.includes('/registration');

  if (!isRegistrationSave) {
    return next(request);
  }

  const saving = inject(SavingService);
  saving.begin();
  return next(request).pipe(finalize(() => saving.end()));
}
